<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<config-sidenav></config-sidenav>
			<div id="content" class="app-content box-shadow-3 w-100">
				<div class="navbar navbar-expand-lg">
					<!-- Page title -->
					<div class="navbar-text nav-title flex" id="pageTitle"> Task Bank Managment. </div>
				</div>

				<div class="content-main" style="background-color:white;">
					<!-- Page content goes here -->
					<div class="h-100" >
						<div class="d-sm-flex b-t h-100">
                            
							<edit-pane
								class="scroll-x"
								style="width: 100%"
								:cancel="loadData"
								:save="saveTaskBank"
								:dirty="dirty"
								:valid="valid"
							>
								<div v-if="!this.loading" class="h-100" >
									<!-- Overall Settings -->
									<div class="tab-pane">
										<div class="row m-0">
											<form role="form" class="p-4 col-sm-6">
                                         
                                                <div class="form-group">
													<label>Bank URL : </label>
													<input
														type="url"
														class="form-control"
														:value="`${user.client.host}/#/public/tasks/${taskbank.ref_id}`"
														readonly
													/>
												</div>
                                            <label class>Active:</label>
                             
		                                        <div class="form-group">
                                                    <label class="ui-switch ui-switch-md theme-accent">
                                                    <input type="checkbox" v-model="taskbank.active" />
                                                    <i></i>
                                                    </label>												
                                                </div>
												<div class="form-group">
													<label>Header Text</label>
													<input type="text" class="form-control" v-model="taskbank.header_text" />
                                                    <small class="form-text text-muted"
														>This will show in the header in the public facing task bank</small
													>
												</div>
												<div
													class="form-group"
												
												>
													<label>Description</label>
													
                                                    <RichText
                                                    :text.sync="taskbank.description"
                                                    :initial="initialText"
                                                    :options="{ height: 140 }"
                                                    class="border"
                                                    ></RichText>

													<small class="form-text text-muted"
														>Shows under the header text.</small
													>
												</div>
							
				                                <div class="form-group">
													<label>Copy Right</label>
                                                    <RichText
                                                    :text.sync="taskbank.copyright"
                                                    :initial="initialCopyRight"
                                                    :options="{ height: 140 }"
                                                    class="border"
                                                    ></RichText>
                                                    <small class="form-text text-muted"
														>This will show in the footer.</small
													>
												</div>

                                    
											</form>
											<form role="form" class="p-4 col-sm-6">
                                                <b>Field Names : </b>

                                                <div class="form-group">
                                                    <small class="form-text text-muted"
														>Standard : </small
													>
													<input type="text" class="form-control" v-model="taskbank.field_names.standard" />
												</div>
                                                <div class="form-group">
                                                    <small class="form-text text-muted"
														>Essential Skill : </small
													>
													<input type="text" class="form-control" v-model="taskbank.field_names.essential_skill" />
												</div>

                                                <div class="form-group">
                                                    <small class="form-text text-muted"
														>Content Area : </small
													>
													<input type="text" class="form-control" v-model="taskbank.field_names.content_area" />
												</div>

                                                <div class="form-group">
                                                    <small class="form-text text-muted"
														>District : </small
													>
													<input type="text" class="form-control" v-model="taskbank.field_names.district" />
												</div>
											</form>
										</div>
									</div>
								</div>
							</edit-pane>
						
						</div>
					</div>
				</div>
			</div>
		</div>
		<mzfooter></mzfooter>
	</div>
</template>

<style scoped>
.margin-overlap {
	margin-right: -2.5rem;
}
.padding{
    padding-bottom: 0px !important;
}
</style>

<script>
import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";
import ImagePicker from "@/components/ImagePicker";
import RichText from "@/components/RichText";

import TaskBankService from "@/services/TaskBankService";
import ValidationService from "@/services/ValidationService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import Utils from "@/services/Utils";

export default {
	name: "TaskBankEdit",

	props: ["user", "params", "query"],

	components: {
		EditPane,
		SaveOptionalModal,
        ImagePicker,
        RichText
	},

	data() {
		return {
			fs: fs,
			tab: 1,
			taskbank: {
                loaded: 0,
                name:"blank"
            },
            loading:true,
            originalDesc: "",
			dirty: false,
            valid: {},
            initialText:"",
            initialCopyRight:"",
			saveOptModal: false,
			saveOptNext: () => {},
			saveOptCancel: () => {}
		};
	},

	computed: {},

	created() {
		this.loadData();
        this.initValidation();
	},

	watch: {},

	beforeRouteLeave(to, from, next) {
		if (this.dirty) {
			this.saveOptNext = () => {
				next();
			};
			this.saveOptCancel = () => {
				next(false);
			};
			this.saveOptModal = true;
		} else {
			next();
		}
	},

	methods: {
		initValidation() {
			this.valid = ValidationService.newValidator({
				header_text: {
					group: "details",
					errorMsg: "You must assign a Header Text",
					func: () => {
						return this.taskbank && this.taskbank.header_text && this.taskbank.header_text != "";
					}
				}
			});
		},
        loadDesc(){
            if(this.taskbank){
                return this.taskbank.description
            }
            return ""
        },
		blankTaskBank() {
			return {
				loaded: 0
			};
		},

		watchChanges() {
			if (this.unwatch) {
				this.unwatch();
			}
			this.unwatch = this.$watch(
				"taskbank",
				(newc, old) => {
					// console.log(newc, old);
					// console.log(Utils.diff(newc, old));
					// console.log("marking dirty");
					this.dirty = true;
				},
				{ deep: true }
			);
		},

		loadData() {
            return TaskBankService.getTaskBank()
                .then(resp => {
                    console.log("Loading Data .. ",resp.data)
                    this.taskbank = resp.data;
                    this.initialText = resp.data.description
                    this.initialCopyRight = resp.data.copyright
                    this.watchChanges();
					this.loading = false
					this.dirty = false
                })
                .catch(err => {
                    console.log(err);
                    Notie.error("TaskBank not found.");
                });
		},

		saveTaskBank() {
			return TaskBankService.saveTaskBank(this.taskbank)
				.then(resp => {
                
					Notie.info("TaskBank Saved");
                    this.loadData();
                    this.dirty = false
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to save TaskBank", err);
				});
		},

		canSave() {
			return this.dirty;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/SetupConfig/TaskBankSetup.vue